import React from 'react';
import { Shield, Database, Trash2, Users, CalendarDays, CheckSquare } from 'lucide-react';
import { useDataStore } from '../context/DataStoreContext';
export function Config() {
  const {
    leads,
    events,
    qaRecords,
    resetAll
  } = useDataStore();
  const handleReset = () => {
    if (window.confirm('¿Estás seguro de que quieres borrar TODOS los datos? Esta acción no se puede deshacer y el CRM volverá a estar completamente vacío.')) {
      resetAll();
      window.alert('Datos borrados correctamente. El CRM está vacío.');
    }
  };
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-852">
      {/* Header */}
      <div data-id="element-853">
        <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-growthly-muted mb-2" data-id="element-854">
          <Shield size={14} data-id="element-855" />
          <span data-id="element-856">Ajustes</span>
        </div>
        <h1 className="text-[32px] md:text-[36px] font-bold text-white leading-tight" data-id="element-857">
          Configuración
        </h1>
        <p className="text-[14px] text-growthly-muted mt-1.5" data-id="element-858">
          Gestiona los ajustes y datos del sistema.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-859">
        {/* Privacidad y GDPR */}
        <div className="card overflow-hidden" data-id="element-860">
          <div className="p-4 border-b border-white/[0.06] flex items-center gap-2.5 bg-gradient-to-br from-white/[0.04] to-transparent" data-id="element-861">
            <div className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center" data-id="element-862">
              <Shield className="w-4 h-4 text-growthly-text" data-id="element-863" />
            </div>
            <h3 className="text-[14px] font-semibold text-white" data-id="element-864">
              Privacidad y GDPR
            </h3>
          </div>
          <div className="divide-y divide-white/[0.04]" data-id="element-865">
            <div className="p-4 flex items-center justify-between gap-3" data-id="element-866">
              <div className="flex items-center gap-3 min-w-0" data-id="element-867">
                <div className="w-8 h-8 rounded-lg bg-white/[0.03] border border-white/[0.06] flex items-center justify-center text-growthly-muted flex-shrink-0" data-id="element-868">
                  <Database className="w-4 h-4" data-id="element-869" />
                </div>
                <span className="text-[13px] font-medium text-growthly-text truncate" data-id="element-870">
                  Políticas de Retención
                </span>
              </div>
              <span className="text-[11px] font-medium px-2.5 py-1 rounded-md bg-growthly-green/15 text-growthly-green border border-growthly-green/20 flex-shrink-0" data-id="element-871">
                Configurado
              </span>
            </div>
            <div className="p-4 flex items-center justify-between gap-3" data-id="element-872">
              <div className="flex items-center gap-3 min-w-0" data-id="element-873">
                <div className="w-8 h-8 rounded-lg bg-white/[0.03] border border-white/[0.06] flex items-center justify-center text-growthly-muted flex-shrink-0" data-id="element-874">
                  <Shield className="w-4 h-4" data-id="element-875" />
                </div>
                <span className="text-[13px] font-medium text-growthly-text truncate" data-id="element-876">
                  Flujos DSAR (Export / Delete)
                </span>
              </div>
              <span className="text-[11px] font-medium px-2.5 py-1 rounded-md bg-growthly-green/15 text-growthly-green border border-growthly-green/20 flex-shrink-0" data-id="element-877">
                Activo
              </span>
            </div>
          </div>
        </div>

        {/* Resumen de datos */}
        <div className="card overflow-hidden" data-id="element-878">
          <div className="p-4 border-b border-white/[0.06] flex items-center gap-2.5 bg-gradient-to-br from-white/[0.04] to-transparent" data-id="element-879">
            <div className="w-8 h-8 rounded-lg bg-white/[0.06] flex items-center justify-center" data-id="element-880">
              <Database className="w-4 h-4 text-growthly-text" data-id="element-881" />
            </div>
            <h3 className="text-[14px] font-semibold text-white" data-id="element-882">
              Resumen de datos
            </h3>
          </div>
          <div className="p-5" data-id="element-883">
            <div className="grid grid-cols-3 gap-3" data-id="element-884">
              <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4" data-id="element-885">
                <div className="flex items-center gap-2 mb-2 text-growthly-muted" data-id="element-886">
                  <Users size={13} data-id="element-887" />
                  <span className="text-[11px] font-medium uppercase tracking-wider" data-id="element-888">
                    Leads
                  </span>
                </div>
                <p className="text-[24px] font-bold text-white leading-none" data-id="element-889">
                  {leads.length}
                </p>
              </div>
              <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4" data-id="element-890">
                <div className="flex items-center gap-2 mb-2 text-growthly-muted" data-id="element-891">
                  <CalendarDays size={13} data-id="element-892" />
                  <span className="text-[11px] font-medium uppercase tracking-wider" data-id="element-893">
                    Eventos
                  </span>
                </div>
                <p className="text-[24px] font-bold text-white leading-none" data-id="element-894">
                  {events.length}
                </p>
              </div>
              <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4" data-id="element-895">
                <div className="flex items-center gap-2 mb-2 text-growthly-muted" data-id="element-896">
                  <CheckSquare size={13} data-id="element-897" />
                  <span className="text-[11px] font-medium uppercase tracking-wider" data-id="element-898">
                    QA
                  </span>
                </div>
                <p className="text-[24px] font-bold text-white leading-none" data-id="element-899">
                  {qaRecords.length}
                </p>
              </div>
            </div>
            <p className="text-[12px] text-growthly-muted mt-4 leading-relaxed" data-id="element-900">
              Todos los datos del CRM se guardan localmente en este navegador.
            </p>
          </div>
        </div>

        {/* Danger zone — full width on md */}
        <div className="md:col-span-2 card overflow-hidden border-growthly-red/20" data-id="element-901">
          <div className="p-4 border-b border-growthly-red/10 flex items-center gap-2.5 bg-growthly-red/[0.06]" data-id="element-902">
            <div className="w-8 h-8 rounded-lg bg-growthly-red/15 flex items-center justify-center" data-id="element-903">
              <Trash2 className="w-4 h-4 text-growthly-red" data-id="element-904" />
            </div>
            <h3 className="text-[14px] font-semibold text-growthly-red" data-id="element-905">
              Zona de Peligro
            </h3>
          </div>
          <div className="p-5 flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-906">
            <div className="flex-1" data-id="element-907">
              <p className="text-[14px] font-semibold text-white mb-1" data-id="element-908">
                Borrar todos los datos del CRM
              </p>
              <p className="text-[13px] text-growthly-muted leading-relaxed max-w-2xl" data-id="element-909">
                Esto eliminará todos los leads, eventos del calendario,
                registros de QA y el historial. El CRM volverá a su estado
                inicial vacío. Esta acción no se puede deshacer.
              </p>
            </div>
            <button onClick={handleReset} className="flex-shrink-0 bg-growthly-red/10 text-growthly-red hover:bg-growthly-red hover:text-white border border-growthly-red/30 hover:border-growthly-red px-5 py-2.5 rounded-lg text-[13px] font-semibold transition-colors whitespace-nowrap" data-id="element-910">
              Empezar de cero
            </button>
          </div>
        </div>
      </div>
    </div>;
}